'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './suite-directory.routes';

export class SuiteDirectoryComponent {
  constructor(IntegrationService, DTOptionsBuilder, $state, $stateParams, Config, SettingsService) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.IntegrationService = IntegrationService;

    this.data = [];
    this.type = $stateParams.type;

    SettingsService.getByName({name: 'suite-directory-config'}, setting => {

      this.config = setting.data[this.type];

      this.pageTitle = this.config.title || Config.getPageTitleByStateWithDefault($state.current.name, "Suite Directory");

      this.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('responsive', true)
        .withOption('order', [0, 'asc'])
        .withOption('buttons',[{
          extend: 'excel',
          title: this.pageTitle
        },{
          extend: 'csv',
          title: this.pageTitle
        },{
          title: this.pageTitle,
          message: 'As of ' + moment().format("MMMM Do YYYY"),
          extend: 'pdf',
          orientation: 'landscape',
          pageSize: 'LETTER'
        },'print']);

      this.IntegrationService.querySuiteLDAP({
        base: btoa(this.config.query.base),
        filter: btoa(this.config.query.filter)
      }, data => {
        this.data = data;
      });
    });
  }
}

export default angular.module('conduuApp.suiteDirectory', [uiRouter])
  .config(routes)
  .component('suiteDirectory', {
    template: require('./suite-directory.html'),
    controller: SuiteDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/suite/suite-directory.component.js